module.exports = __webpack_public_path__ + "img/how-works-thumb-2.bcd8eb76.png";